<div class="card w-[500px]" style="width: 500px">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <strong class="text-lg font-semibold text-gray-800 dark:text-gray-100">View Marketing Item</strong>
  </div>

  <!-- Card Body -->
  <div *ngIf="item" class="p-4 text-sm text-gray-800 dark:text-gray-200 space-y-2">
    <div class="flex justify-between">
      <span class="font-medium">Marketing ID:</span>
      <span>{{ item.marketingId }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Report Date:</span>
      <span>{{ item.reportDate | date : 'MM/dd/yyyy' }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Marketing Type:</span>
      <span>{{ item.marketingTypeName }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Submit Date:</span>
      <span>{{ item.submitDate | date : 'MM/dd/yyyy' }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Submitted By:</span>
      <span>{{ item.submittedBy }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Approve Date Advisor:</span>
      <span>{{ item.approveDateAdvisor | date : 'MM/dd/yyyy' }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Approved By Advisor CCO:</span>
      <span>{{ item.approvedByAdvisorCco }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Approved by Fund CCO:</span>
      <span>{{ item.approvedByFundCco }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Approve Date Fund CCO:</span>
      <span>{{ item.approveDateFundCco | date : 'MM/dd/yyyy' }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Approved By Fund Dist:</span>
      <span>{{ item.approvedbyFundDist }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Approve Date Fund Dist:</span>
      <span>{{ item.approveDateFundDist | date : 'MM/dd/yyyy' }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Description:</span>
      <span>{{ item.description }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Entity:</span>
      <span>{{ item.marketingEntityTypeName }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Performance Data Included:</span>
      <span>{{ item.performanceDataIncluded }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Distribution Method:</span>
      <span>{{ item.marketingDistributionMethodTypeName }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Distribution Quantity:</span>
      <span>{{ item.marketingDistributionQuantityName }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Submitted To NASD:</span>
      <span>{{ item.submittedToNasd }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Date of First Use:</span>
      <span>{{ item.dateOfFirstUse | date : 'MM/dd/yyyy' }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Assigned To:</span>
      <span>{{ item.assignedTo }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Modified By:</span>
      <span>{{ item.modifiedBy }}</span>
    </div>
    <div class="flex justify-between">
      <span class="font-medium">Modified Date:</span>
      <span>{{ item.modifiedDate | date : 'MM/dd/yyyy' }}</span>
    </div>
  </div>
</div>
